/**
 * QB Status hook — consolidated to use the primary Supabase project.
 * TODO: Decommission sandbox project (maltrtjtputdznaloovz) once validated in production.
 */
import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

interface QBStatus {
  connected: boolean;
  lastSyncedAt: string | null;
  realmId: string | null;
  isLoading: boolean;
  companyId: string | null;
  refetch: () => void;
}

export function useQBStatus(): QBStatus {
  const [connected, setConnected] = useState(false);
  const [lastSyncedAt, setLastSyncedAt] = useState<string | null>(null);
  const [realmId, setRealmId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [companyId, setCompanyId] = useState<string | null>(null);

  const fetchStatus = useCallback(async () => {
    setIsLoading(true);
    try {
      // get_qb_status now lives in the primary project and uses my_company_id() internally
      const { data, error } = await supabase.rpc("get_qb_status" as any);

      if (error) {
        console.error("Failed to get QB status:", error);
        setConnected(false);
        setLastSyncedAt(null);
      } else if (data) {
        const result = typeof data === "object" && data !== null ? data : {};
        setConnected((result as any).connected ?? false);
        setLastSyncedAt((result as any).last_synced_at ?? null);
        setRealmId((result as any).realm_id ?? null);
      }

      // Also fetch company_id for connect/disconnect flows
      const { data: cid } = await supabase.rpc("my_company_id" as any);
      setCompanyId(cid ?? null);
    } catch (err) {
      console.error("QB status error:", err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return { connected, lastSyncedAt, realmId, isLoading, companyId, refetch: fetchStatus };
}
